import {
  formatUsPhoneInput,
  getUsNationalDigits,
  isValidUsPhoneNumber,
  normalizeUsPhone,
} from './usPhoneNumber';

const SEX_ALIASES = {
  m: "male",
  male: "male",
  man: "male",
  f: "female",
  female: "female",
  woman: "female",
  other: "other",
  nonbinary: "other",
  "non-binary": "other",
};

export function normalizeSex(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return SEX_ALIASES[normalized] || normalized;
}

export function normalizeDate(value) {
  if (!value) return "";
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().slice(0, 10);
}

export function normalizePhone(value) {
  return normalizeUsPhone(value);
}

export function phoneDigits(value) {
  return getUsNationalDigits(value);
}

export function isValidUsPhone(value) {
  return isValidUsPhoneNumber(value);
}

export function formatUsPhone(value) {
  return formatUsPhoneInput(value);
}

export function normalizePatientProfile(patient = {}) {
  const firstName = patient.first_name || patient.firstName || "";
  const lastName = patient.last_name || patient.lastName || "";
  const fullName = patient.name || `${firstName} ${lastName}`.trim() || patient.email || "";
  return {
    id: patient.id || patient.patient_id || patient.patientId || null,
    first_name: firstName,
    last_name: lastName,
    name: fullName,
    email: patient.email || "",
    phone: normalizePhone(patient.phone || patient.phone_number || patient.mobile_phone || ""),
    dob: normalizeDate(patient.dob || patient.date_of_birth || patient.dateOfBirth || patient.birth_date),
    sex: normalizeSex(patient.sex_at_birth || patient.sex || patient.gender || patient.sexAtBirth),
    address: {
      street: patient.address || patient.street || patient.address_line_1 || "",
      apt: patient.apt || patient.apartment || patient.address_line_2 || "",
      city: patient.city || "",
      state: String(patient.state || "").toUpperCase(),
      zip: patient.zip || patient.zip_code || patient.postal_code || "",
    },
  };
}
